import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import Logger from '../utils/logger';

const initial = {
  city: null,
  agnosticCity: null,
};

const fetchDeltaWifiConfigDataThunk = createAsyncThunk(
  'configs/fetchDeltaWifi',
  async ({
    baseRequestUrl,
    locationPath,
  }) => {
    const assetsEndpoint = `${baseRequestUrl}DeltaWifi/DeltaWifiConfig.json`;
    const response = await fetch(assetsEndpoint, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Access-Control-Allow-Origin': baseRequestUrl,
      },
      mode: 'cors',
    });
    const configDataJson = await response.json();
    return {
      locationPath,
      configDataJson,
    };
  }
);

const handleError = (e = {}) => {
  const { message = '' } = e;
  Logger.error(`[ERROR] Amex DeltaWifi Slice: load, ${message}`);
};

const amexDeltaWifiSlice = createSlice({
  name: 'deltaWifiConfig',
  initialState: initial,
  reducers: {
    setAgnosticCity: (state, action) => {
      state.agnosticCity = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDeltaWifiConfigDataThunk.fulfilled, (state, action) => {
      const {
        locationPath,
        configDataJson,
      } = action.payload;

      if (configDataJson) {
        const pathArr = locationPath.split('/');
        let urlValue = '';
        if (pathArr.length === 3) {
          [, , urlValue] = pathArr;
          const cityData = configDataJson.find((item) => item.url_value === urlValue);

          if (cityData) {
            const { city: cityValue } = cityData;
            state.city = cityValue;
          } else {
            state.city = { error: true };
          }
        } else {
          state.city = {};
        }
      }
    });
    builder.addCase(fetchDeltaWifiConfigDataThunk.rejected, (state, action) => {
      handleError(action.error);
      state.city = {};
    });
  },
});

const fetchCityName = (baseRequestUrl, locationPath) => (dispatch) => dispatch(fetchDeltaWifiConfigDataThunk({ baseRequestUrl, locationPath }));

const { setAgnosticCity } = amexDeltaWifiSlice.actions;

export { fetchCityName, fetchDeltaWifiConfigDataThunk, setAgnosticCity };
export default amexDeltaWifiSlice.reducer;
